import Color from 'color';

const ACCENT_DARKEN_RATIO = 0.75;

const FALLBACK_DARK = Color.rgb(2, 2, 2);

function headerAccentFromAverage(
	average: { readonly r: number; readonly g: number; readonly b: number } | undefined,
): InstanceType<typeof Color> {
	if (!average) return FALLBACK_DARK;
	try {
		return Color(average).darken(ACCENT_DARKEN_RATIO);
	} catch {
		return FALLBACK_DARK;
	}
}

export function headerTitleAreaBackground(
	average: { readonly r: number; readonly g: number; readonly b: number } | undefined,
): string {
	return headerAccentFromAverage(average).rgb().string();
}

export function headerMobileImageOverlayGradient(
	average: { readonly r: number; readonly g: number; readonly b: number } | undefined,
): string {
	const accent = headerAccentFromAverage(average);
	const base = average ? Color(average) : FALLBACK_DARK;
	return `linear-gradient(180deg, ${base.alpha(0).rgb().string()} 0%, ${base.alpha(0).rgb().string()} 43%, ${base.alpha(0.08).rgb().string()} 50%, ${accent.alpha(0.6).rgb().string()} 70%, ${accent.rgb().string()} 100%)`;
}

export function headerDesktopTitleFadeGradient(
	average: { readonly r: number; readonly g: number; readonly b: number } | undefined,
): string {
	const accent = headerAccentFromAverage(average);
	const base = average ? Color(average) : FALLBACK_DARK;
	return `linear-gradient(177deg, ${base.alpha(0).rgb().string()} 0%, ${base.alpha(0.08).rgb().string()} 35.51%, ${accent.alpha(0.8).rgb().string()} 56%, ${accent.rgb().string()} 69.34%)`;
}
